import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css"
import iconClipboardCheck from 'data-url:../images/icon_clipboard_check.svg';

window.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('header');
    const setHeaderVisibility = (isVisible) => {
        header.hidden = !isVisible;
    };

    let linkCopiedToast = null;

    document.addEventListener('download-link-copied', () => {
        if (linkCopiedToast) {
            linkCopiedToast.hideToast();
        }

        linkCopiedToast = Toastify({
            avatar: iconClipboardCheck,
            text: "Link copied",
            duration: 3000,
            gravity: "bottom",
            position: "center",
            offset: {
                y: 30
            }
        });

        linkCopiedToast.showToast();
    });

    // components/upload-container.js (the Lit-based upload flow) dispatches these on
    // itself (bubbles, composed) instead of touching #header directly — it doesn't own
    // #header, this script does. See _plans/4.5-lit_upload_container_component.md Step 7.
    document.addEventListener('upload-started', () => setHeaderVisibility(false));
    document.addEventListener('upload-reset', () => setHeaderVisibility(true));
});